import React from "react";
import {
  includeManePlus,
  includeManeSelect,
  includeAppris,
  includeUniprotId,
  includeTSL,
  isProteinLevelAvailable,
  showGeneColumn,
} from "./helpers";
import HelperText from "../../../../components/atoms/HelperText";

export const allCodingLocationsNull = (transcripts) => {
  // Check if coding_location exists for any transcript
  // If not, we will hide the column
  for (let i = transcripts.length - 1; i >= 0; i--) {
    if (transcripts[i].coding_location) {
      return false;
    }
  }
  return true;
};

export const allSpliceDistancesNull = (transcripts) => {
  // Check if splice_distance exists for any transcript
  // If not, we will hide the column
  for (let i = transcripts.length - 1; i >= 0; i--) {
    if (transcripts[i].splice_distance) {
      return false;
    }
  }

  return true;
};

export const calculateLocationBrackets = (transcript) => {
  // calculate what to include in brackets after location
  let locationBrackets = "";
  const transcriptFunction = transcript.function;
  if (Array.isArray(transcriptFunction)) {
    for (let i = transcriptFunction.length - 1; i >= 0; i--) {
      const f = transcriptFunction[i];
      // If it contains 5'flank, 5'utr, 3'flank, 3'utr ignore
      if (f.indexOf("5") === -1 && f.indexOf("3") === -1) {
        if (locationBrackets) {
          locationBrackets = `${locationBrackets}, ${f}`;
        } else {
          locationBrackets = f;
        }
      }
    }
    if (locationBrackets) {
      locationBrackets = ` (${locationBrackets})`;
    }
  }

  return locationBrackets;
};

export const renderTableHeader = (schema, variantResult, transcripts) => {
  return (
    <thead>
      <tr>
        <th width="20%">
          {schema.name.label}
          <HelperText fieldDescriptionKey="Transcript" />
        </th>
        <th>
          {schema.coding_impact.label}
          <HelperText fieldDescriptionKey="Coding impact" />
        </th>
        {showGeneColumn(variantResult) && <th>Gene</th>}
        <th>
          {schema.hgvs.label}
          <HelperText fieldDescriptionKey="HGVS coding" />
        </th>
        {isProteinLevelAvailable(transcripts) && (
          <th>
            HGVS Protein
            <HelperText fieldDescriptionKey="HGVS protein level" />
          </th>
        )}
        <th>
          {schema.location.label}
          <HelperText fieldDescriptionKey="Location" />
        </th>
        {!allCodingLocationsNull(transcripts) && (
          <th>
            {schema.coding_location.label}
            <HelperText fieldDescriptionKey="Coding location" />
          </th>
        )}
        {!allSpliceDistancesNull(transcripts) && (
          <th>
            {schema.splice_distance.label}
            <HelperText fieldDescriptionKey={schema.splice_distance.label} />
          </th>
        )}
        {includeTSL(transcripts) && (
          <th width="5%">
            {"TSL "}
            <HelperText fieldDescriptionKey="TSL" />
          </th>
        )}
        {includeManePlus(transcripts) && (
          <th width="8%">
            {"MANE Plus Clinical "}
            <HelperText fieldDescriptionKey="MANE Plus Clinical" />
          </th>
        )}
        {includeManeSelect(transcripts) && (
          <th width="8%">
            {"MANE Select "}
            <HelperText fieldDescriptionKey="MANE Select" />
          </th>
        )}
        {includeAppris(transcripts) && (
          <th width="8%">
            {"APPRIS "}
            <HelperText fieldDescriptionKey="APPRIS" />
          </th>
        )}
        {includeUniprotId(transcripts) && (
          <th width="8%">
            UniProt Accession
            <HelperText fieldDescriptionKey="UniProt Accession" />
          </th>
        )}
      </tr>
    </thead>
  );
};

export const renderFunctionalAnnotationNotice = () => {
  return (
    <div className="varsome-inner-container varsome-text-center">
      <small className="varsome-text-muted">
        This functional annotation is calculated on the fly for all variants,
        known or unknown
      </small>
    </div>
  );
};
